if (!customElements.get('cart-packaging-options')) {
  customElements.define(
    'cart-packaging-options',
    class CartPackagingOptions extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        const option = event.target.closest('[data-packaging-variant-id]');
        if (!option || this.hasAttribute('aria-busy')) return;

        const selectedVariantId = Number(this.dataset.selectedVariantId);
        const requestedVariantId = Number(option.dataset.packagingVariantId);
        const nextVariantId = selectedVariantId === requestedVariantId ? 0 : requestedVariantId;
        const detailsWasOpen = Boolean(this.querySelector('details')?.open);
        const existingConfigurableGiftTitle = this.dataset.existingConfigurableGiftTitle;
        if (nextVariantId > 0 && existingConfigurableGiftTitle) {
          const confirmed =
            typeof window.confirmExtraGiftPackaging === 'function' &&
            (await window.confirmExtraGiftPackaging(existingConfigurableGiftTitle));
          if (!confirmed) return;
        }
        const packagingVariantIds = [Number(this.dataset.hamperVariantId), Number(this.dataset.giftBoxVariantId)].filter(
          (variantId) => variantId > 0
        );
        const updates = {};

        packagingVariantIds.forEach((variantId) => {
          updates[variantId] = variantId === nextVariantId ? 1 : 0;
        });

        this.setLoading(true);
        this.showError();

        try {
          const response = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              updates,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();

          if (!response.ok || state.errors) {
            throw new Error(state.description || state.message || window.cartStrings.error);
          }

          const drawer = document.querySelector('cart-drawer');
          drawer.setActiveElement(document.activeElement);
          drawer.renderContents(state);

          const refreshedDetails = drawer.querySelector('cart-packaging-options details');
          if (refreshedDetails) refreshedDetails.open = detailsWasOpen;

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-packaging',
            cartData: state,
            variantId: nextVariantId,
          });
        } catch (error) {
          this.showError(error.message || window.cartStrings.error);
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.toggleAttribute('aria-busy', isLoading);
        this.querySelectorAll('button').forEach((button) => {
          button.disabled = isLoading;
        });

        const status = this.querySelector('[role="status"]');
        if (status) status.textContent = isLoading ? 'Updating gift packaging…' : '';
      }

      showError(message = '') {
        const error = this.querySelector('[role="alert"]');
        if (!error) return;

        error.textContent = message;
        error.hidden = !message;
      }
    }
  );
}
